import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {formatDate} from "utils";
import ColumnClassNamesType from 'propTypes/columnClassNamesType';

const DateCell = (props) => {
  const { contact, value, columnClassNames } = props;

  return (
    <td className={classNames('contact-list-react-type-date', columnClassNames)}>
      {contact[value] ? formatDate(contact[value]) : ''}
    </td>
  );
};

DateCell.propTypes = {
  contact: PropTypes.shape({
    id: PropTypes.string
  }),
  value: PropTypes.string,
  columnClassNames: ColumnClassNamesType
};

DateCell.defaultProps = {
  contact: {},
  value: ''
};

export default DateCell;
